// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.messageModalBody__LQL3r3wQds{min-width:500px}`, "",{"version":3,"sources":["webpack://./src/assets/components/conversation/components/header/toolbar/components/transferToAgent/components/transferToAgentDropdown/components/confirmTransferModal/confirmTransferModal.module.scss"],"names":[],"mappings":"AAAA,8BACE,eAAA","sourcesContent":[".messageModalBody {\n  min-width: 500px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"messageModalBody": `messageModalBody__LQL3r3wQds`
};
export default ___CSS_LOADER_EXPORT___;
